/**
 * ChangelogPage - Renders the portal change log from `changelog.md`.
 */

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '@/i18n/namespaces';
import { LegalPageLayout } from '../shared/LegalPageLayout';
import { MarkdownRenderer } from '../shared/markdown-renderer';
import changelogContent from '@/content/legal/changelog.md';

export const ChangelogPage: React.FC = () => {
  const { t } = useTranslation(NS.COMMON);
  const title = t('Changelog_PageTitle', 'Change Log');

  useEffect(() => {
    if (typeof document !== 'undefined') document.title = `${title} – ECGrid`;
  }, [title]);

  return (
    <LegalPageLayout>
      <MarkdownRenderer content={changelogContent as unknown as string} />
    </LegalPageLayout>
  );
};

ChangelogPage.displayName = 'ChangelogPage';

export default ChangelogPage;
